module.exports = __webpack_public_path__ + "img/10-estatus-enproceso.39c22ec0.svg";